import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useLinePlanningStatusConditionsContext() {
  const { linePlanningStatusConditions } =
    useContext<GlobalContextType>(GlobalContext);
  return linePlanningStatusConditions;
}
